<template>
	<div>
			<!-- Stock Days Start -->
			<div class="p-10 shadow rounded">
				<div class=" Aligner-Header mt-4">
					<h3>Stock Days</h3>
				</div>
				<div class="row mt-2 ml-4">
					<div class="col-md-4 col-12 row" style="padding-top:6px;">
						<div class="col" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px"
								type="button" 
								class="w-100 btn" 
								:class="{'btn-outline-primary' : stockDaysButtonOptions != 'MD', 'btn-primary' : stockDaysButtonOptions == 'MD'}" 
								@click="stockDaysButtonOptions = 'MD'"
							>
								Main Dealer
							</button>
						</div>
						<div class="col" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px"
								type="button" 
								class="w-100 btn" 
								:class="{'btn-outline-primary' : stockDaysButtonOptions != 'D', 'btn-primary' : stockDaysButtonOptions == 'D'}" 
								@click="stockDaysButtonOptions = 'D'"
							>
								Dealer
							</button>
						</div>
					</div>
					<div class="col-md-1 col-12"/>
					<div class="col-12 offset-md-1 col-md-7 row">
						<template v-if="stockDaysButtonOptions == 'MD'">
							<div class="col-12 offset-md col-md highlightFilter" >
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.mainDealer.map(x => x.code)"
									:custom-label="opt => options.stockDays.mainDealer.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockDaysOptions.mainDealer"
									placeholder="All Main Dealer"
								/>
							</div>
							<div class="col-12 col-md highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.type.map(x => x.type)"
									:allow-empty="true"
									v-model="filter.stockDaysOptions.type"
									placeholder="All Type"
								/>
							</div>
							<div class="col-12 col-md highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.color.map(x => x.color)"
									:custom-label="opt => options.stockDays.color.find(x => x.color == opt).name"
									:allow-empty="true"
									v-model="filter.stockDaysOptions.color"
									placeholder="All Color"
								/>
							</div>
						</template>
						<template v-else>
							<div class="col-12 offset-md col-md highlightFilter" >
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.karesidenan.map(x => x.code)"
									:allow-empty="true"
									v-model="filter.stockDaysOptionsDealer.karesidenan"
									placeholder="All Karesidenan"
								/>
							</div>
							<div class="col-12 offset-md col-md highlightFilter" >
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.dealer.map(x => x.code)"
									:custom-label="opt => options.stockDays.dealer.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockDaysOptionsDealer.dealer"
									placeholder="All Dealer"
								/>
							</div>
							<div class="col-12 col-md highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.type.map(x => x.type)"
									:allow-empty="true"
									v-model="filter.stockDaysOptionsDealer.type"
									placeholder="All Type"
								/>
							</div>
							<div class="col-12 col-md highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockDays.color.map(x => x.color)"
									:custom-label="opt => options.stockDays.color.find(x => x.color == opt).name"
									:allow-empty="true"
									v-model="filter.stockDaysOptionsDealer.color"
									placeholder="All Color"
								/>
							</div>
							
						</template>
						
					</div>
				</div>
				<div class="row mt-1" style="padding-right:1.25%">
				<div class="col-md-5 col-12"/>
				<div class="col-md-7 col-12 row" >
					<div class="col-md-2 col-12"/>
					<div class="col-md col-12 row highlightFilter">
						<div class="col-3" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeYear('min')"
								:disabled="this.year <= 2019"
							>
								<i class="fa fa-caret-left" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
						<div class="col-6" style="padding-left:0;padding-right:0">
							<p
								class="btn w-100"
								style="border: 1px solid #FF9700;border-radius:0px"
							>
								{{year}}
							</p>
						</div>
						<div class="col-3" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeYear('add')"
								:disabled="this.year >= parseInt(new moment().format('Y'))"
							>
								<i class="fa fa-caret-right" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
					</div>
					<div class="col-md col-12 row highlightFilter">
						<div class="col-3" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeMonth('min')"
								:disabled="this.min >= this.month.value"
							>
								<i class="fa fa-caret-left" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
						<div class="col-6" style="padding-left:0;padding-right:0">
							<p
								class="btn w-100"
								style="border: 1px solid #FF9700;border-radius:0px"
							>
								{{month.name}}
							</p>
						</div>
						<div class="col-3" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeMonth('add')"
								:disabled="this.max <= this.month.value"
							>
								<i class="fa fa-caret-right" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
					</div>
					<div class="col-md col-12 row highlightFilter">
						<div class="col-3" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeWeek('min')"
								:disabled="this.week.value <= 1"
							>
								<i class="fa fa-caret-left" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
						<div class="col-6" style="padding-left:0;padding-right:0">
							<p
								class="btn w-100"
								style="border: 1px solid #FF9700;border-radius:0px"
							>
								{{week.name}}
							</p>
						</div>
						<div class="col-3" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px;border: 1px solid #FF9700"
								type="button" 
								class="w-100 btn btn-primary"
								@click="changeWeek('add')"
								:disabled="this.week.value >= 4"
							>
								<i class="fa fa-caret-right" aria-hidden="true" style="color:white"></i>
							</button>
						</div>
						
					</div>

				</div>
			</div>
				<div class="content-outer">
				<div class="content-inner" style="padding: 2% 2% 0 2%">
					<div class="row">
					<div class="col" style="display: flex; flex-direction: row-reverse;">
						<!-- <p style="font-size: large; color: #707070; font-weight: bold;">Stock Days as of today <span style="font-size: x-large;">{{stockDaysAvg}}</span></p> -->
					</div>
					</div>
					<stock-days-chart
					:period="period"
					:mdData= "data.stockDaysMD"
					:dData= "data.stockDaysD"
					:endData= "data.stockDaysEnd"
					:week="weekNo"
					:type="stockDaysButtonOptions"
					v-on:setAverageStockDays="updateAverageStockDays"
					v-if="data.stockDaysMD && data.stockDaysD"
					></stock-days-chart>
					<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
				</div>
				</div>
			</div>
			<!-- Stock Days End -->

			<!-- Stock Days Market Start -->
			<div class="p-10 shadow rounded mt-4 mb-4">
				<div class="row pr-5">
					<div class="col-md-10">
						<div class="Aligner-Header mt-4">
							<h3>Stock Days Market</h3>
						</div>
					</div>
					<div class="col-md-2 pl-0">
						<div class="highlightFilter" style="height: 41px;">
							<button
								type="button"
								class="mt-4 btn btn-warning w-100 h-100"
								@click="exportStockDaysMarket"
							>Download CSV <i class="fas fa-download"></i></button>
						</div>
					</div>
				</div>

				<div class="row mt-3 mr-3" >
					<div class="col-md-5 col-12"></div>
					<div class="col-md-7 col-12 row" style="padding-top:6px;">
						<div class="col-md-8 col-12"></div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.stockDaysMarket.type.map(x => x.type)"
								:allow-empty="true"
								v-model="filter.stockDaysMarket.type"
								placeholder="All Type"
							/>
						</div>
					</div>
				</div>

				<div class="content-outer">
					<div class="content-inner row" style="padding: 2%;">
						<!-- {{data.stockDaysMarket}} -->
						<stockDaysMarket
							v-if="data.stockDaysMarket"
							class="w-100"
							:data="data.stockDaysMarket"
						/>
					</div>
					
				</div>

				
			</div>
			<!-- Stock Days Market End -->

			<!-- Aging Stock Analysis Start -->
			<div class="shadow rounded p-10 mt-4 mb-4">
				<div class="Aligner-Header mt-4">
					<h3>Aging Stock Analysis</h3>
				</div>
				<div class="row mt-3 ml-4" >
				<div class="col-md-4 col-12 row" style="padding-top:6px;">
					<!-- <div class="col" style="padding-right:0">
						<button 
							style="border-radius : 6px 0px 0px 6px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : agingStockButtonOptions != 'endtoend', 'btn-primary' : agingStockButtonOptions == 'endtoend'}" 
							@click="agingStockButtonOptions = 'endtoend'"
						>
							End To End
						</button>
					</div> -->
					<div class="col" style="padding-right:0">
						<button 
							style="border-radius : 6px 0px 0px 6px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : agingStockButtonOptions != 'maindealer', 'btn-primary' : agingStockButtonOptions == 'maindealer'}" 
							@click="agingStockButtonOptions = 'maindealer'"
						>
							Main Dealer
						</button>
					</div>
					<div class="col" style="padding-left:0">
						<button 
							style="border-radius : 0px 6px 6px 0px"
							type="button" 
							class="w-100 btn" 
							:class="{'btn-outline-primary' : agingStockButtonOptions != 'dealer', 'btn-primary' : agingStockButtonOptions == 'dealer'}" 
							@click="agingStockButtonOptions = 'dealer'"
						>
							Dealer
						</button>
					</div>
				</div>
				<div class="col-md-1 col-12"></div>
				<div class="col-12 offset-md-1 col-md-7 row">
					<template v-if="agingStockButtonOptions == 'maindealer'">
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.mainDealer.map(x => x.code)"
								:custom-label="opt => options.agingStock.mainDealer.find(x => x.code == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptions.mainDealer"
								placeholder="All Main Dealer"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.gudang.map(x => x.code)"
								:custom-label="opt => options.agingStock.gudang.find(x => x.code == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptions.warehouse"
								placeholder="All Gudang"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.category.map(x => x.category)"
								:allow-empty="true"
								v-model="filter.agingStockOptions.category"
								placeholder="All Category"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.color.map(x => x.color)"
								:custom-label="opt => options.agingStock.color.find(x => x.color == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptions.color"
								placeholder="All Color"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter pt-3">
							<div style="height: 41px;">
								<button
									type="button"
									class="btn btn-warning w-100 h-100"
									@click="exportExcelAgingStock('maindealer' , filter.agingStockOptions)"
								>Download CSV <i class="fas fa-download"></i></button>
							</div>
						</div>
						<div class="col-12 col-md-4 highlightFilter pt-3">
							<flat-pickr v-model="filter.agingStockOptions.period" :config="rangeConfig" :placeholder="'Select Date'"/>
						</div>
					</template>
					<template v-else>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.karesidenan.map(x => x.code)"
								:custom-label="opt => options.agingStock.karesidenan.find(x => x.code == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptionsDealer.karesidenan"
								placeholder="All Karesidenan"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.dealer.map(x => x.code)"
								:custom-label="opt => options.agingStock.dealer.find(x => x.code == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptionsDealer.dealer"
								placeholder="All Dealer"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.category.map(x => x.category)"
								:allow-empty="true"
								v-model="filter.agingStockOptionsDealer.category"
								placeholder="All Category"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.agingStock.color.map(x => x.color)"
								:custom-label="opt => options.agingStock.color.find(x => x.color == opt).name"
								:allow-empty="true"
								v-model="filter.agingStockOptionsDealer.color"
								placeholder="All Color"
							/>
						</div>
						<div class="col-12 col-md-4 highlightFilter pt-3">
							<div style="height: 41px;">
								<button
									type="button"
									class="btn btn-warning w-100 h-100"
									@click="exportExcelAgingStock('dealer' , filter.agingStockOptionsDealer)"
								>Download CSV <i class="fas fa-download"></i></button>
							</div>
						</div>
						<div class="col-12 col-md-4 highlightFilter pt-3">
							<flat-pickr v-model="filter.agingStockOptionsDealer.period" :config="rangeConfig" :placeholder="'Select Date'"/>
						</div>
					</template>
				</div>
				</div>
				<div class="content-outer">
					<div class="content-inner row" style="padding: 2%;">
						<div class="col-12 col-md-8">
							<aging-stock-main-dealer-analysis-bar-chart :data="data.agingStockMD[0]" :dealerData="data.agingStockD[0]" :endData="data.agingStockEnd[0]" :selected="agingStockButtonOptions" v-if="data.agingStockMD && data.agingStockD && data.agingStockEnd" @agingSelected="setShowModal"
							></aging-stock-main-dealer-analysis-bar-chart>
							<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
						</div>
						<div class="col-12 col-md-4">
							<aging-stock-main-dealer-analysis-pie-chart :data="data.agingStockMD[0]" :dealerData="data.agingStockD[0]" :endData="data.agingStockEnd[0]" :selected="agingStockButtonOptions" v-if="data.agingStockMD && data.agingStockD && data.agingStockEnd"
							></aging-stock-main-dealer-analysis-pie-chart>
							<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
						</div>
					</div>
					
				</div>

				<hr>
				<div class="row mt-4 pl-2 pr-5">

					<div class="Aligner-Header col-md-4 col-12 mt-2 pt-3">
						<h3>Aging Stock Details</h3>
					</div>
					<div class="col-md-2 col-12 mt-2 pt-3">
						<button class="btn btn-outline-primary w-100" style="height:41px" @click="showModal = !showModal">{{showModal ? 'Hide' : 'Show'}} Table</button>
					</div>
					<div class="col-md-2 col-12 mt-2 offset-md-2 highlightFilter" v-if="showModal">
						<Multiselect
								class="mt-1 "
								:options="monthFilter.map(x => x.var)"
								:custom-label="opt => monthFilter.find(x => x.var == opt).name"
								:allow-empty="false"
								v-model="agingRange"
							/>
					</div>
					<div class="col-md-2 col-12 mt-2 pt-3" :class="{'offset-md-4' : !showModal}" v-if="showModal">
						<button class="btn btn-primary w-100" style="height:41px" @click="downloadAgingStock">Download CSV</button>
					</div>

					<div class="col-12 pl-4">
						<AgingStockModal
							v-if="showModal"
							:agingRange="agingRange"
							:location="agingStockButtonOptions"
							:filter="filter.agingStockOptions"
							ref="agingStockTable"
						/>
					</div>
				</div>


				<!-- <div class="row mt-4" v-if="data.agingStockMDMeta && data.agingStockEndMeta && data.agingStockDMeta">
					<div class="col-md-2 col-0"></div>
					<div class="col-md-4 col-12 p-8">
						<agingStockStats :dataMD="data.agingStockMDMeta.aging_stock_tertinggi" :dataD="data.agingStockDMeta.aging_stock_tertinggi" :dataEnd="data.agingStockEndMeta.aging_stock_tertinggi" :selected="agingStockButtonOptions" :text="'Tertinggi'" />
					</div>
					<div class="col-md-4 col-12 p-8">
						<agingStockStats :dataMD="data.agingStockMDMeta.aging_stock_terendah" :dataD="data.agingStockDMeta.aging_stock_terendah" :dataEnd="data.agingStockEndMeta.aging_stock_terendah" :selected="agingStockButtonOptions" :text="'Terendah'" />
					</div>
					<div class="col-md-2  col-0"></div>
				</div> -->
				<!-- <p class="ml-5 mt-2" style="color:grey;font-size:13px;font-weight:bold">Aging Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p> -->
			</div>
			<!-- Aging Stock Analysis End -->

			<!-- Stock By Production Years Start -->
			<div class="shadow rounded p-10 mt-4 mb-4">
				<div class="row pr-5">
					<div class="col-md-10">
						<div class="Aligner-Header mt-4">
							<h3>Stock By Production Years</h3>
						</div>
					</div>
					<div class="col-md-2 pl-0">
						<div class="highlightFilter" style="height: 41px;">
							<button
								type="button"
								class="mt-4 btn btn-warning w-100 h-100"
								@click="exportStockByProductionYears"
							>Download CSV <i class="fas fa-download"></i></button>
						</div>
					</div>
				</div>
				<div class="row mt-3 ml-4" >
					<div class="col-md-4 col-12 row" style="padding-top:6px;">
						<!-- <div class="col" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px"
								type="button" 
								class="w-100 btn" 
								:class="{'btn-outline-primary' : agingStockButtonOptions != 'endtoend', 'btn-primary' : agingStockButtonOptions == 'endtoend'}" 
								@click="agingStockButtonOptions = 'endtoend'"
							>
								End To End
							</button>
						</div> -->
						<div class="col" style="padding-right:0">
							<button 
								style="border-radius : 6px 0px 0px 6px"
								type="button" 
								class="w-100 btn" 
								:class="{'btn-outline-primary' : stockByProductionYearsOptions != 'maindealer', 'btn-primary' : stockByProductionYearsOptions == 'maindealer'}" 
								@click="stockByProductionYearsOptions = 'maindealer'"
							>
								Main Dealer
							</button>
						</div>
						<div class="col" style="padding-left:0">
							<button 
								style="border-radius : 0px 6px 6px 0px"
								type="button" 
								class="w-100 btn" 
								:class="{'btn-outline-primary' : stockByProductionYearsOptions != 'dealer', 'btn-primary' : stockByProductionYearsOptions == 'dealer'}" 
								@click="stockByProductionYearsOptions = 'dealer'"
							>
								Dealer
							</button>
						</div>
					</div>
					<div class="col-md-1 col-12"></div>
					<div class="col-12 offset-md-1 col-md-7 row">
						<template v-if="stockByProductionYearsOptions == 'maindealer'">
							<div class="col-12 col-md-4 offset-md-4 highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockByProductionYears.mainDealer.map(x => x.code)"
									:custom-label="opt => options.stockByProductionYears.mainDealer.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockByProductionYearsOptions.mainDealer"
									placeholder="All Main Dealer"
								/>
							</div>
							<div class="col-12 col-md-4 highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockByProductionYears.gudang.map(x => x.code)"
									:custom-label="opt => options.stockByProductionYears.gudang.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockByProductionYearsOptions.warehouse"
									placeholder="All Gudang"
								/>
							</div>
						</template>
						<template v-else>
							<div class="col-12 col-md-4 offset-md-4 highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockByProductionYears.karesidenan.map(x => x.code)"
									:custom-label="opt => options.stockByProductionYears.karesidenan.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockByProductionYearsOptionsDealer.karesidenan"
									placeholder="All Karesidenan"
								/>
							</div>
							<div class="col-12 col-md-4 highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.stockByProductionYears.dealer.map(x => x.code)"
									:custom-label="opt => options.stockByProductionYears.dealer.find(x => x.code == opt).name"
									:allow-empty="true"
									v-model="filter.stockByProductionYearsOptionsDealer.dealer"
									placeholder="All Dealer"
								/>
							</div>
						</template>
					</div>
				</div>
				<div class="content-outer">
					<div class="content-inner row" style="padding: 2%;">
						<div class="col-md-9" style="height:400px">
							<stock-by-production-years
								v-if="data.stockByProductionYearsMD && data.stockByProductionYearsD"
								:data="data.stockByProductionYearsMD"
								:dealerData="data.stockByProductionYearsD"
								:selected="stockByProductionYearsOptions"
								style="height:100%"
							></stock-by-production-years>
							<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
						</div>
						<div class="col-md-3" style="height:400px">
							<stock-by-production-years-table
								v-if="data.stockByProductionYearsMD && data.stockByProductionYearsD"
								:data="data.stockByProductionYearsMD"
								:dealerData="data.stockByProductionYearsD"
								:selected="stockByProductionYearsOptions"
								style="height:100%; overflow:auto"
							></stock-by-production-years-table>
							<div v-else style="text-align:center; margin-top:20px"><h4>Loading...</h4></div>
						</div>
					</div>
					
				</div>
			</div>
			<!-- Stock By Production Years End -->

			<!-- Movement Stock Start -->
			<div class="shadow rounded p-10">
				<div class="Aligner-Header">
					<h3>Movement Stock (Transfer Vehicles Between Warehouse)</h3>
				</div>
				<div class="row mt-3 ml-3">
					<div class="col-md-5 row">
						
						<div class="col-md-6 highlightFilter">
							<label class="h5">From :</label>
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.gudang"
								:searchable="true"
								:close-on-select="true"
								:show-labels="false"
								label="name"
								:allow-empty="true"
								v-model="filter.movementStockOptions.warehouse"
								placeholder="Select Warehouse"
							/>
						</div>
						<div class="col-md-6 highlightFilter">
							<label class="h5">To :</label>
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.gudang"
								:searchable="true"
								:close-on-select="true"
								:show-labels="false"
								label="name"
								:allow-empty="true"
								v-model="filter.movementStockOptions.destination"
								placeholder="Select Warehouse"
							/>
						</div>
					</div>
					<div class="col-md-1"></div>
					<div class="col-md-6 row">
						<div class="col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.mainDealer.map(x => x.code)"
								:custom-label="opt => options.movementStock.mainDealer.find(x => x.code == opt).name"
								:allow-empty="true"
								v-model="filter.movementStockOptions.mainDealer"
								placeholder="All Main Dealer"
							/>
						</div>
						<div class="col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.segment.map(x => x.segment)"
								:allow-empty="true"
								v-model="filter.movementStockOptions.segment"
								placeholder="All Segment"
							/>
						</div>
						<div class="col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.type.map(x => x.type)"
								:allow-empty="true"
								v-model="filter.movementStockOptions.type"
								placeholder="All Type"
							/>
						</div>
						<div class="col-md-4 highlightFilter">
							<Multiselect
								class="mt-1 "
								:options="options.movementStock.color.map(x => x.color)"
								:custom-label="opt => options.movementStock.color.find(x => x.color == opt).name"
								:allow-empty="true"
								v-model="filter.movementStockOptions.color"
								placeholder="All Color"
							/>
						</div>
						<div class="col-md-8 highlightFilter">
							<div class="form-group m-0">
								<!-- <label>Date Range</label> -->
								<date-range-picker 
									class="w-100 mr-4"
									v-model="movementRange"
									style="min-height:43px"
									ref="picker"
									:opens="'left'"
									:ranges="rangeOption.Monthly"
									:locale-data="{ firstDay: 1, format: 'MMM DD, YYYY' }"
								>
									<template v-slot:input="picker" style="min-width: 350px;" class="text-center">
										<i class="fa fa-calendar fa-fw ml-n1"></i> 
										{{ moment(picker.startDate).format("DD/MM/YY")}} - {{ moment(picker.endDate).format("DD/MM/YY")}}
										<b class="caret"></b>
									</template>
								</date-range-picker>
							</div>
						</div>
					</div>
				</div>
				<div v-if="filter.movementStockOptions.warehouse && filter.movementStockOptions.destination">
					<div class="row" >
						<div class="col-md-4">
							<movement-stock-vehicle-chart
								:filter="filter.movementStockOptions"
								:period="period"
								:options="options"
								:data="data.movementStockSubSeries"
								v-if="data.movementStockSubSeries"
							></movement-stock-vehicle-chart>
						</div>
						<div class="col-md-1"></div>
						<div class="col-md-7">
							<movement-stock-table
								class="w-100"
								:filter="filter.movementStockOptions"
								:period="period"
								:data="data.movementStockTable"
							></movement-stock-table>
						</div>
						
					</div>
					<p class="ml-5 mt-2" style="color:grey;font-size:13px;font-weight:bold">Movement Stock Calculated as of {{new moment().format('MMM DD, Y HH:mm')}}</p>
				</div>
				<div v-else class="mt-4 mb-3">
					<h4 class="text-center">Please Select Both Warehouse From And Warehouse Destination to use this feature.</h4>
				</div>
			</div>
			<!-- Movement Stock End -->

			<!-- Outer Stock Start -->
			<div class="shadow rounded p-10 mt-4 mb-4">
				<!-- <div class="row pr-5">
					<div class="col-md-10">
						
					</div>
		
				</div> -->
				<div class="row mt-3 ml-4" >
					<div class="col-md-4 col-12">
						<div class="Aligner-Header mt-4">
							<h3>Gudang NTT</h3>
						</div>
					</div>
					
					<div class="col-md-1 col-12"></div>
					<div class="col-12 offset-md-1 col-md-7 row">
						<template>
							<div class="col-12 col-md-4  highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.outerStock.subSeries.map(x => x.subSeries)"
									:allow-empty="true"
									v-model="filter.outerStockOptions.series"
									placeholder="All Series"
								/>
							</div>
							<div class="col-12 col-md-4  highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.outerStock.type.map(x => x.type)"
									:allow-empty="true"
									v-model="filter.outerStockOptions.type"
									placeholder="All Type"
								/>
							</div>
							<div class="col-12 col-md-4 highlightFilter">
								<Multiselect
									class="mt-1 "
									:options="options.outerStock.color.map(x => x.color)"
									:custom-label="opt => options.outerStock.color.find(x => x.color == opt).name"
									:allow-empty="true"
									v-model="filter.outerStockOptions.color"
									placeholder="All Color"
								/>
							</div>
						</template>
					</div>
				</div>
				<div class="content-outer">
					<div class="content-inner row" style="padding: 2%;">
						<div class="col-12">
							<outerStock 
								v-if="data.outerStock"
								:data="data.outerStock"
							/>
						</div>
					</div>
					
				</div>
			</div>
			<!-- End Outer Stock-->

			
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import moment from 'moment'
	const XLSX = require('xlsx')
	import DateRangePicker from 'vue2-daterange-picker'
	import flatPickr from 'vue-flatpickr-component'
	import movementStockTable from './../children/movementStockTable.vue'
	import movementStockVehicleChart from './../children/movementStockVehicleChart.vue'
	import movementStockAreaChart from './../children/movementStockAreaChart.vue'
	import stockDaysChart from './../children/stockDaysChart.vue'
	import agingStockMainDealerAnalysisBarChart from './../children/agingStockAnalysis/mainDealerBarChart.vue'
	import agingStockMainDealerAnalysisPieChart from './../children/agingStockAnalysis/mainDealerPieChart.vue'
	import agingStockEndToEndChart from './../children/agingStockAnalysis/agingStockEndToEndChart'
	import averageAgingStockMainDealer from './../children/averageAgingStock/mainDealerChart.vue'
	import agingStockStats from './../children/agingStockAnalysis/agingStockStats'
	import AgingStockModal from './../children/agingStockAnalysis/AgingStockModal'
	import stockByProductionYears from './../children/stockByProductionYears/stockByProductionYears'
	import stockByProductionYearsTable from './../children/stockByProductionYears/stockByProductionYearsTable'
	import stockDaysMarket from './../children/stockDaysMarket.vue'
	import outerStock from './../children/outerStock'

	import listUrl from './../listUrl.js'

export default {
	components: {
		Multiselect,
		flatPickr,
		DateRangePicker,
		movementStockTable,
		movementStockVehicleChart,
		movementStockAreaChart,
		stockDaysChart,
		agingStockMainDealerAnalysisBarChart,
		agingStockMainDealerAnalysisPieChart,
		agingStockEndToEndChart,
		averageAgingStockMainDealer,
		agingStockStats,
		AgingStockModal,
		stockByProductionYears,
		stockByProductionYearsTable,
		stockDaysMarket,
		outerStock
	},
	props: ['period', 'mobile', 'data', 'filter', 'weekNo', 'rangeOption'],
	data () {
		return {
			rangeConfig: {
				altInput: true,
				altInputClass: 'form-control input flatpickr-input',
				animate: !this.isRTL()
			},
			movementStockButtonOptions: 'Chart Summary',
			averageAgingStockButtonOptions: 'MD',
			stockDaysButtonOptions: 'MD',
			agingStockButtonOptions: 'maindealer',
			stockByProductionYearsOptions : 'maindealer',
			stockDaysAvg: 0,
			options : {
				stockDays : this.$store.getters.getFilterOptions,
				agingStock : this.$store.getters.getFilterOptions,
				stockByProductionYears : this.$store.getters.getFilterOptions,
				movementStock : this.$store.getters.getFilterOptions,
				stockDaysMarket : this.$store.getters.getFilterOptions,
				outerStock : this.$store.getters.getFilterOptions
			},
			movementRange  : {
				startDate : this.filter.movementStockOptions.start,
				endDate : this.filter.movementStockOptions.end,
			},
			month : {
				object : new moment(),
				value: new moment().month(),
				name: new moment().format("MMMM")
			},
			monthFilter : [{
				name : '1 Month',
				var : 'month_1'
			},{
				name : '2 Months',
				var : 'month_2'
			},{
				name : '3 Months',
				var : 'month_3'
			},{
				name : '3 - 6 Months',
				var : 'month_3_6'
			},{
				name : '> 6 Months',
				var : 'month_6'
			}],
			week: {
				value: 1,
				name: "Week 1"
			},
			year : parseInt(new moment().format('Y')),
			min: 0,
			max: 11,
			showModal : false,
			agingRange : 'month_1',
			moment : moment
		}
	},
	mounted () {
		this.setUpMonthValidation()
		this.$emit('search')
		
	},
	watch: {
		weekNo : function () {
			console.log(this.weekNo)
		},
		period : function() {
			this.setUpMonthValidation()
		},
		'filter.agingStockOptions.mainDealer' () {
			this.filter.agingStockOptions.warehouse = ''
			
			this.options.agingStock.gudang = this.$store.getters.getGudangBySingleId(this.filter.agingStockOptions.mainDealer);
		},
		'filter.movementStockOptions.mainDealer' () {
			this.filter.movementStockOptions.warehouse = ''
			this.filter.movementStockOptions.destination = ''

			this.options.movementStock.gudang = this.$store.getters.getGudangBySingleId(this.filter.movementStockOptions.mainDealer);
		},
		'filter.movementStockOptions.segment' () {
			this.filter.movementStockOptions.type = ''
			
			this.options.movementStock.type = this.$store.getters.getTypeBySingleId(null, this.filter.movementStockOptions.segment, null);
		},
		"filter.agingStockOptions": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.agingStockAnalysis
				let params = listUrl.param.stockAnalytics.agingStockAnalysis

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.agingStockOptionsDealer": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.agingStockAnalysis
				let params = listUrl.param.stockAnalytics.agingStockAnalysis

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockDaysMarket": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.stockDaysMarket
				let params = listUrl.param.stockAnalytics.stockDaysMarket

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockDaysOptions": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.stockDays
				let params = listUrl.param.stockAnalytics.stockDays

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.outerStockOptions": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.outerStock
				let params = listUrl.param.stockAnalytics.outerStock

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockDaysOptionsDealer": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.stockDays
				let params = listUrl.param.stockAnalytics.stockDays

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockDaysOptionsDealer.karesidenan" () {
			this.filter.stockDaysOptionsDealer.dealer = ''
			
			this.options.stockDays.dealer = this.$store.getters.getDealerBySingleId(this.filter.stockDaysOptionsDealer.karesidenan , null);
		},
		"filter.agingStockOptionsDealer.karesidenan" () {
			this.filter.agingStockOptionsDealer.dealer = ''
			
			this.options.agingStock.dealer = this.$store.getters.getDealerBySingleId(this.filter.agingStockOptionsDealer.karesidenan , null);
		},
		"filter.movementStockOptions": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.movementStock
				let params = listUrl.param.stockAnalytics.movementStock

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockByProductionYearsOptions": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.stockByProductionYears
				let params = listUrl.param.stockAnalytics.stockByProductionYears

				this.$emit('loadAPI' , url , params )
			}
		},
		"filter.stockByProductionYearsOptionsDealer": {
			deep: true,
			handler: function () {
				let url = listUrl.stringUrl.stockAnalytics.stockByProductionYears
				let params = listUrl.param.stockAnalytics.stockByProductionYears

				this.$emit('loadAPI' , url , params )
			}
		},
		movementRange : function() {
			this.filter.movementStockOptions.start = new moment(this.movementRange.startDate).format('Y-MM-DD')
			this.filter.movementStockOptions.end = new moment(this.movementRange.endDate).format('Y-MM-DD')

			// let start =  new moment(this.movementRange.startDate).format("Y-MM-DD").split('-')
			// if(this.optionRangeTerritory == 'Semester')
			// 	this.labelTerritory = parseInt(start[1]) > 6 ? `S2 ${start[0]}` : `S1 ${start[0]}`
			// else if(this.optionRangeTerritory == 'Quarterly')
			// 	this.labelTerritory = parseInt(start[1]) < 4 ? `Q1 ${start[0]}` : parseInt(start[1]) < 7 ? `Q2 ${start[0]}` : parseInt(start[1]) < 10 ? `Q3 ${start[0]}` : `Q4 ${start[0]}`
			// else 
			// 	this.labelTerritory = `Custom`

		},
	},
	methods : {
		exportStockDaysMarket () {
			this.exportFile(this.data.stockDaysMarket, 'Stock Days Market');
		},
		async downloadAllStockTable () {
			let url = `/api/highlight/aging-stock-analysis/table?location=${this.agingStockButtonOptions}&month=all`

            let filter = await this.initialiseFilter(this.filter.agingStockOptions)

            this.$http.get(url + filter)
            .then((resp) => {
                let data = resp.data.data
				let wb = XLSX.utils.book_new()
				var ws = XLSX.utils.json_to_sheet(data, { raw: "true" });
				XLSX.utils.book_append_sheet(wb, ws, 'Data')
				XLSX.writeFile(wb, `All Time Aging Stock.xls`)
            })
            .catch((err)=> { console.log(err) })
		},
		initialiseFilter (filter) {
            let filterString = '&'
            let keys = Object.keys(filter)
            // console.log(filter)

            for(var i = 0 ;  i < keys.length  ; i++) {
                if(filter[keys[i]] != '')
                filterString += `${keys[i]}=${filter[keys[i]]}&`
            }

            return filterString
        },
		downloadAgingStock() {
			this.$swal.fire({
				title: '<strong>Download CSV</strong>',
				type: 'info',
				html:
					'Pick time range for downloading the csv for aging stock details.',
				showCloseButton: true,
				showCancelButton: true,
				focusConfirm: false,
				confirmButtonText:
					'Current Selected Month',
				cancelButtonText:
					'All Month',
			}).then((result) => {
				if (result.isConfirmed) {
					this.$refs.agingStockTable.export()
				}
				else {
					this.downloadAllStockTable()
				}
			})
			// 
		},
		setFilterDate() {
			this.filter.stockDaysOptions.month = this.month.value + 1
			this.filter.stockDaysOptions.year = this.year

			this.filter.stockDaysOptionsDealer.month = this.month.value + 1
			this.filter.stockDaysOptionsDealer.year = this.year
		},
		setShowModal (aging) {
			this.agingRange = aging
			console.log(aging)
			this.showModal = true
		},
		updateAverageStockDays(avg) {
			this.stockDaysAvg = avg
		},
		changeYear(flag) {
			if(flag == 'add') {
				this.year++
			}else {
				this.year--;
			}

			this.setFilterDate()
		},
		changeMonth(flag) {
			if(flag == 'add') {
				let object = this.month.object.add(1 , 'months')
				this.month = {
					object: object,
					value: object.month(),
					name: object.format("MMMM")
				}
			}
			else {
				let object = this.month.object.subtract(1 , 'months')
				this.month = {
					object: object,
					value: object.month(),
					name: object.format("MMMM")
				}
			}
			this.setFilterDate()
		},
		changeWeek(flag) {
			if(flag == 'add') {
				this.week.value++
				this.week.name = `Week ${this.week.value}`

				// this.weekNo = this.week.value
			}
			else {
				this.week.value--
				this.week.name = `Week ${this.week.value}`
				// this.weekNo = this.week.value
				
			}
			this.$emit('weekNo' , this.week.value)
		},
		setUpMonthValidation() {
			this.min = 0
			this.max = 11
			this.month = {
				object : new moment(),
				value: new moment().month(),
				name: new moment().format("MMMM")
			}
		},
		exportStockByProductionYears() {
			let url = `/api/highlight/stock-by-production-years/`
			let name;
			let currDate = new moment().format("YYYY-MM-DD");

			if (this.stockByProductionYearsOptions == 'maindealer') {
				url += "export-maindealer"
				name = `MD Stock By Production Years ${currDate}`
			} else if (this.stockByProductionYearsOptions == 'dealer'){
				url += "export-dealer"
				name = `Dealer Stock By Production Years ${currDate}`
			} else return;

			url += `?period=${currDate}`

			this.$http.get(url)
			.then((resp)=>{
				console.log(JSON.stringify(resp.data.data));
				this.exportFile(resp.data.data, name);
			})
			.catch((err)=>{console.log(err)})
		},
		exportFile(data, fileName){
			let wb = XLSX.utils.book_new()
			var ws = XLSX.utils.json_to_sheet(data, {raw:true});
			XLSX.utils.book_append_sheet(wb, ws, 'Data')
			XLSX.writeFile(wb, `${fileName}.xlsx`)
		},
		async exportExcelAgingStock(type , filter) {
			try {
				let url = `/api/highlight/aging-stock-analysis/${type}-summary-download?`
				url = url + this.initialiseFilter(filter)
				let resp = await this.$http.get(url)

				let data = resp.data.data

				this.exportFile(data , 'Aging Stock ' + type)
			}
			catch(err) {
				console.log(err)
			}
		}
	}
}
</script>

<style scoped>
	.btn-primary {
		background-color: #FF9700;
		border-color: #FF9700;
	}

	.btn-outline-primary {
		border-color: #FF9700;
		color: #FF9700;
	}

	.btn-outline-primary:hover {
		background-color: #FF9700;
		color: white;
	}

	.btn-outline-primary:focus {
		background-color:#FF9700;
	}

	.movement-stock-from-to {
		text-align:center;
		display:flex;
		flex-direction:column;
		justify-content: center;
		font-weight:bold;
		font-size:16px;
	}
</style>